import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const PartyBundleCTA = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto bg-frost-berry rounded-[3rem] overflow-hidden shadow-2xl">
        <div className="grid md:grid-cols-2 items-center">
          <div className="p-12 md:p-16 text-frost-vanilla">
            <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-sm font-bold tracking-wider uppercase mb-6 backdrop-blur-sm">
              <SafeIcon icon="FiStar" /> Most Value
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Throwing a gathering? <br/> Get the Party Cooler.
            </h2>
            <p className="text-frost-ice mb-8 text-lg opacity-90">
              12 assorted pints in a reusable premium dry-ice cooler. Pick your own flavors or let our chefs curate a crowd-pleasing mix. Guaranteed to stay frozen for 48 hours upon delivery.
            </p>
            <button className="bg-white text-frost-berry px-8 py-4 rounded-full font-bold text-lg hover:bg-frost-ice transition-colors duration-300 shadow-lg">
              Build Your Cooler - $120
            </button>
          </div>
          <div className="h-full min-h-[400px] relative">
            <img 
              src="https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&q=80&w=1000" 
              alt="Party Ice Cream Assortment" 
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartyBundleCTA;